<template>
  <div class="definition">
    <div class="definition__info definition__info--purpose">
      <div class="info">
        <h1 class="info__title">Purpose</h1>
          <dots-number activeDots='1'/>


        <div class="info text-center">
          <div class="info__header">
            <p class="info__header-text">
              All activities and people are directed by and find meaning in a purpose that
              goes beyond financial performance to create a positive impact on the world and
              purposeful advantage for the organisation.
            </p>
          </div>
          <div>
            <div class="info__body text-left">
              <p class="info__body-text font-weight-bold mb-4">
                Our assessment of Purpose examines the following areas:
              </p>
              <ol>
                <li class="info__body-text"><b>Positive Impact</b>
                  – Members, customers, stakeholders and partners are confident in the
                  organisation's ability to create a positive impact on the world.</li>
                <li class="info__body-text"><b>Purpose Clarity</b>
                   – Members understand the reason the organisation exists,
                  and how their activities contribute to fulfilling its key outcomes.</li>
                <li class="info__body-text"><b>Meaning</b>
                   – People in the organisation take pride in the work that it does,
                   creating a strong emotional connection to the organisation’s purpose. </li>
                <li class="info__body-text"><b>Belonging</b>
                   – Members are bound together by the organisation’s purpose,
                   and every member feels they are appreciated for contributing to fulfilling that purpose.</li>
              </ol>
              <div class="info__footer pb-0">
              </div>
            </div>
          </div>
        </div>
        <go-back-button/>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import DotsNumber from '@/components/Evaluation/Dots';
import GoBackButton from '@/components/Helpers/GoBackButton';

export default {
  components: { DotsNumber, GoBackButton },
  data() {
    return {
      id: 3,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Definition/Purpose.vue